// extracted by mini-css-extract-plugin
module.exports = {"base":"LogoHorizontal-base-1M8aA","hiddenTitle":"LogoHorizontal-hiddenTitle-mDHBt"};